import { render } from "./PlayerFiltersForm.vue?vue&type=template&id=ec8fb026"
import script from "./PlayerFiltersForm.vue?vue&type=script&lang=js"
export * from "./PlayerFiltersForm.vue?vue&type=script&lang=js"

import "./PlayerFiltersForm.vue?vue&type=style&index=0&id=ec8fb026&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__